export enum DialogVariantEnum {
  IN_TRANSLATION = 'IN_TRANSLATION',
  IMPORT = 'IMPORT',
  DELETE = 'DELETE',
  CANCEL = 'CANCEL',
  SIMILAR_OPERATION = 'SIMILAR_OPERATION',
  SEND = 'SEND',
  CHANGE_DUE_DATE_PROJECT = 'CHANGE_DUE_DATE_PROJECT',
  CHANGE_DUE_DATE_JOB = 'CHANGE_DUE_DATE_JOB',
  ADD_LANGUAGES = 'NEW_LANGUAGES',
  REMOVE_LANGUAGES = 'REMOVE_LANGUAGES',
  REMOVE_LANGUAGE = 'REMOVE_LANGUAGE',
  CONTENT_CHANGED = 'CONTENT_CHANGED',
  CONTENT_CHANGED_PROJECT = 'CONTENT_CHANGED_PROJECT',
  CONTENT_REMOVED = 'CONTENT_REMOVED',
  PROJECT_CANCELLED = 'PROJECT_CANCELLED',
  WORKFLOW = 'WORKFLOW',
  PARTIAL_WORKFLOW = 'PARTIAL_WORKFLOW',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  DOWNLOAD_UNSUCCESSFUL = 'DOWNLOAD_UNSUCCESSFUL',
  NO_STATUS = 'NO_STATUS',
  NO_SUPPORTED_ELEMENT = 'NO_SUPPORTED_ELEMENT',
  CANCEL_UNSUCCESSFUL = 'CANCEL_UNSUCCESSFUL',
  ITEM_NOT_SUPPORTED = 'ITEM_NOT_SUPPORTED',
  GENERIC_ERROR = 'GENERIC_ERROR',
}
